<!-- command-bar -->
<div class="cbar">
  <div class="ms-CommandBar">
    <div class="ms-CommandBar-mainArea">
      <div class="ms-CommandButton">
        <button
          (click)="abrirModalCrear()"
          class="ms-CommandButton-button"
          type="button"
        >
          <span class="ms-CommandButton-icon ms-fontColor-themePrimary"
            ><i class="ms-Icon ms-Icon--CalculatorAddition"></i
          ></span>
          <span class="ms-CommandButton-label">Nuevo</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="pageContent">
  <div class="pageTitle">
    <h2>Tipos de Conectores</h2>
  </div>
  <app-data-table
    tableId="datatableTipoConectores"
    [serverSide]="true"
    [serverData]="getDataTableTipoConectores"
    [columns]="columnas"
    (loadedGrid)="gridLoaded($event)"
    (custom)="customClick($event)"
    [buttonsOptions]="dtOptButtons"
  ></app-data-table>
</div>

<!-- Nuevo/Editar -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader create-tipo-conectores" appPreventOutsideClick>
    <div id="dialogCreateEdit" class="ms-Dialog-title">Crear Tipo de Conector</div>
    <form
      [formGroup]="tipoConectorForm"
      (ngSubmit)="crearEditarTipoConector()"
      name="tipoConectorForm"
    >
      <div class="ms-Dialog-content input-grid form-group">
        <div>
          <app-text-box
            [frm]="tipoConectorForm"
            formControlName="Nombre"
            type="text"
            [required]="true"
            label="Nombre"
          ></app-text-box>
        </div>
        <div>
          <app-text-area
            [frm]="tipoConectorForm"
            formControlName="Descripcion"
            [required]="true"
            label="Descripción"
            rows="3"
          ></app-text-area>
        </div>
        <div>
          <app-text-box
            [frm]="tipoConectorForm"
            formControlName="Version"
            type="number"
            [required]="true"
            label="Versión"
            (input)="onInputChange($event)"
          ></app-text-box>
        </div>
        <app-check-box
          [frm]="tipoConectorForm"
          formControlName="TodosUsuarios"
          label="Todos Usuarios"
        ></app-check-box>
        <app-check-box
          [frm]="tipoConectorForm"
          formControlName="Activo"
          label="Activo"
        ></app-check-box>
      </div>
      <app-form-buttons
        [botonProcesando]="botonProcesando"
        buttonCancelId="btnCancel"
        labelCancel="Cancelar"
        buttonSaveId="btnCreateEdit"
        labelSave="Crear"
        [labelLoading]="textoBotonProcesando"
        [frm]="tipoConectorForm"
        (cancel)="clearFormTipoConector()"
        [validate]="true"
      >
      </app-form-buttons>
    </form>
  </div>
</div>

<!-- Modal Almacenado -->
<div class="docs-DialogExample-lgHeader success">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-succes" appPreventOutsideClick> 
    <div class="ms-Dialog-title">Tipo de Conector Almacenado Correctamente</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">Se ha almacenado el Tipo de Conector.</p>
    </div>
    <div class="ms-Dialog-actions">
      <button
        class="ms-Button ms-Dialog-action ms-Button--primary"
        (click)="cerrarModal()"
      >
        <span class="ms-Button-label">Aceptar</span>
      </button>
    </div>
  </div>
</div>

<app-modal-notify #crearModal></app-modal-notify>
